import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { AccordionModule, ButtonModule } from '@com-delta-idp/mnx-ui-kit';
import {
  BusinessProfileView,
  PermissionType
} from './models/business-profile-selector.models';

@Component({
  selector: 'idp-business-profile-selector',
  templateUrl: './business-profile-selector.component.html',
  styleUrls: ['./business-profile-selector.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, ButtonModule, AccordionModule]
})
export class BusinessProfileSelectorComponent implements OnInit {
  @Input() pageData = {} as BusinessProfileView;
  @Input() businessStateSelected = { selectedState: false, accountIndex: 0 };
  @Output() emitCompanyTitle = new EventEmitter();

  show = this.businessStateSelected.selectedState;
  permissionDiv!: number;
  isBusinessPath!: boolean;
  PERM_TYPE_B = 'B';
  PERM_TYPE_NA = 'NA';

  ngOnInit() {
    this.show = this.businessStateSelected.selectedState;
  }

  expand(index: number): void {
    if (this.permissionDiv === index) {
      this.show = !this.show;
    }

    if (this.permissionDiv !== index) {
      this.permissionDiv = index;
      this.show = true;
    }
  }

  isBusinessOnlyPath(permType: PermissionType[]): boolean {
    if (permType.length === 1) {
      return (
        permType[0].permType === this.PERM_TYPE_B ||
        permType[0].permType === this.PERM_TYPE_NA
      );
    }
    return false;
  }

  noExpand(
    companyName: string,
    permType: PermissionType[],
    accountIndex: number,
    displayInlineText?: string | boolean,
    isOaSmeAccount?: boolean,
    partnerId?: string | boolean,
    restrictOnePax?: string | boolean,
    disableMiles?: string | boolean
  ): void {
    this.onClick(
      companyName,
      permType[0].permType,
      accountIndex,
      displayInlineText,
      isOaSmeAccount,
      partnerId,
      restrictOnePax,
      disableMiles
    );
  }

  onClick(
    companyName: string,
    permType: string,
    accountIndex: number,
    displayInlineText?: string | boolean,
    isOaSmeAccount?: boolean,
    partnerId?: string | boolean,
    restrictOnePax?: string | boolean,
    disableMiles?: string | boolean
  ): void {
    this.emitCompanyTitle.emit({
      companyName,
      permType,
      accountIndex,
      displayInlineText,
      isOaSmeAccount,
      partnerId,
      restrictOnePax,
      disableMiles
    });
  }
}
